import contracts from './contracts'
import { FarmConfig, QuoteToken } from './types'

const farms: FarmConfig[] = [
  {
    pid: 0,
    risk: 5,
    lpSymbol: 'LIKE-BUSD',
    lpAddresses: {
      97: '0xc10660856eac280276e6815326ffbea506390024',
      56: '0x95f4ea60949fb8abb3d1bb114fbcb8e8e012b41f',
    },
    tokenSymbol: 'LIKE',
    tokenAddresses: {
      97: '0xeb44841d356b706684460eef19c7e577986bd637',
      56: '0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 1,
    risk: 5,
    lpSymbol: 'LIKE-BNB',
    lpAddresses: {
      97: '0x3dbd669f87d3094be9131de698fb0bdb15b906eb',
      56: '0xa3c81bbcbff337a9754816fb8559121332c4d9b4',
    },
    tokenSymbol: 'LIKE',
    tokenAddresses: {
      97: '0xeb44841d356b706684460eef19c7e577986bd637',
      56: '0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 8,
    risk: 1,
    lpSymbol: 'LIKE-USDT',
    lpAddresses: {
      97: '0xc114165652d66b263dda5d7c1c57d9e54f86cc52',
      56: '0xc114165652d66b263dda5d7c1c57d9e54f86cc52',
    },
    tokenSymbol: 'LIKE',
    tokenAddresses: {
      97: '0xeb44841d356b706684460eef19c7e577986bd637',
      56: '0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
    },
    quoteTokenSymbol: QuoteToken.USDT,
    quoteTokenAdresses: contracts.usdt,
  },
  {
    pid: 7,
    risk: 1,
    lpSymbol: 'USDT-BUSD',
    lpAddresses: {
      97: '0x7abf762b2ea1f3b2a72b3e1c01b8822fb831fe57',
      56: '0x7abf762b2ea1f3b2a72b3e1c01b8822fb831fe57',
    },
    tokenSymbol: 'USDT',
    tokenAddresses: {
      97: '0x55d398326f99059ff775485246999027b3197955',
      56: '0x55d398326f99059ff775485246999027b3197955',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
   {
    pid: 9,
    risk: 5,
    lpSymbol: 'USDT-BNB',
    lpAddresses: {
      97: '0xfcb9a5f2c25de43c0a48d7370c9bedfe62914526',
      56: '0xfcb9a5f2c25de43c0a48d7370c9bedfe62914526',
    },
    tokenSymbol: 'USDT',
    tokenAddresses: {
      97: '0x7afd064DaE94d73ee37d19ff2D264f5A2903bBB0',
      56: '0x55d398326f99059ff775485246999027b3197955',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
     {
    pid: 12,
    risk: 5,
    lpSymbol: 'USDC-BNB',
    lpAddresses: {
      97: '0xe7358c03f2595f96ee833e6cb28c837d58525b3d',
      56: '0xe7358c03f2595f96ee833e6cb28c837d58525b3d',
    },
    tokenSymbol: 'USDC',
    tokenAddresses: {
      97: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
      56: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 2,
    risk: 3,
    lpSymbol: 'BUSD-BNB',
    lpAddresses: {
      97: '0xe0e92035077c39594793e61802a350347c320cf2',
      56: '0xbf82df15664dfc173035a296bf2056186e43dd9c',
    },
    tokenSymbol: 'BNB',
    tokenAddresses: {
      97: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
      56: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  
    {
    pid: 10,
    risk: 5,
    lpSymbol: 'BTCB-BNB',
    lpAddresses: {
      97: '0x46e2019d4d9507b155da71bb9a9d2a56cd40b4b9',
      56: '0x46e2019d4d9507b155da71bb9a9d2a56cd40b4b9',
    },
    tokenSymbol: 'BTCB',
    tokenAddresses: {
      97: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      56: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
      {
    pid: 14,
    risk: 5,
    lpSymbol: 'ETH-BNB',
    lpAddresses: {
      97: '0x25ca6ea112340fe6acc4024c4391914de8c1c297',
      56: '0x25ca6ea112340fe6acc4024c4391914de8c1c297',
    },
    tokenSymbol: 'ETH',
    tokenAddresses: {
      97: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
      56: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 16,
    risk: 5,
    lpSymbol: 'LIKE-BNB PancakeSwap',
    lpAddresses: {
      97: '0x3dbd669f87d3094be9131de698fb0bdb15b906eb',
      56: '0x53094F1894269aBC597287A28d11abE46007fE03',
    },
    tokenSymbol: 'LIKE',
    tokenAddresses: {
      97: '0xeb44841d356b706684460eef19c7e577986bd637',
      56: '0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
   {
    pid: 17,
    risk: 5,
    lpSymbol: 'LIKE-BUSD PancakeSwap',
    lpAddresses: {
      97: '0xc10660856eac280276e6815326ffbea506390024',
      56: '0x45035411BD8089C009847C47031314BFf34fceDe',
    },
    tokenSymbol: 'LIKE',
    tokenAddresses: {
      97: '0xeb44841d356b706684460eef19c7e577986bd637',
      56: '0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  
{
    pid: 3,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'LIKE',
    lpAddresses: {
      97: '0xeb44841d356b706684460eef19c7e577986bd637',
      56: '0x95f4ea60949fb8abb3d1bb114fbcb8e8e012b41f',
    },
    tokenSymbol: 'LIKE',
    tokenAddresses: {
      97: '0xeb44841d356b706684460eef19c7e577986bd637',
      56: '0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },

  
  {
    pid: 4,
    risk: 1,
    isTokenOnly: true,
    lpSymbol: 'BUSD',
    lpAddresses: {
      97: '0x95f4ea60949fb8abb3d1bb114fbcb8e8e012b41f',
      56: '0x95f4ea60949fb8abb3d1bb114fbcb8e8e012b41f', // LIKE-BUSD LP (BUSD-BUSD will ignore)
    },
    tokenSymbol: 'BUSD',
    tokenAddresses: {
      97: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
      56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },

  {
    pid: 6,
    risk: 1,
    isTokenOnly: true,
    lpSymbol: 'USDT',
    lpAddresses: {
      97: '0x7abf762b2ea1f3b2a72b3e1c01b8822fb831fe57',
      56: '0x7abf762b2ea1f3b2a72b3e1c01b8822fb831fe57', // USDT-BUSD LP
    },
    tokenSymbol: 'USDT',
    tokenAddresses: {
      97: '0x55d398326f99059ff775485246999027b3197955',
      56: '0x55d398326f99059ff775485246999027b3197955',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
    {
    pid: 13,
    risk: 1,
    isTokenOnly: true,
    lpSymbol: 'USDC',
    lpAddresses: {
      97: '0xe7358c03f2595f96ee833e6cb28c837d58525b3d',
      56: '0xe7358c03f2595f96ee833e6cb28c837d58525b3d', // USDC-BNB LP
    },
    tokenSymbol: 'USDC',
    tokenAddresses: {
      97: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
      56: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
       {
    pid: 5,
    risk: 3,
    isTokenOnly: true,
    lpSymbol: 'WBNB',
    lpAddresses: {
      97: '0xbf82df15664dfc173035a296bf2056186e43dd9c',
      56: '0xbf82df15664dfc173035a296bf2056186e43dd9c', // BUSD-BNB LP
    },
    tokenSymbol: 'WBNB',
    tokenAddresses: {
      97: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      56: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 11,
    risk: 3,
    isTokenOnly: true,
    lpSymbol: 'BTCB',
    lpAddresses: {
      97: '0x46e2019d4d9507b155da71bb9a9d2a56cd40b4b9',
      56: '0x46e2019d4d9507b155da71bb9a9d2a56cd40b4b9', // BTCB-BNB LP
    },
    tokenSymbol: 'BTCB',
    tokenAddresses: {
      97: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      56: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 15,
    risk: 3,
    isTokenOnly: true,
    lpSymbol: 'ETH',
    lpAddresses: {
      97: '0x25ca6ea112340fe6acc4024c4391914de8c1c297',
      56: '0x25ca6ea112340fe6acc4024c4391914de8c1c297', // ETH-BNB LP
    },
    tokenSymbol: 'ETH',
    tokenAddresses: {
      97: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
      56: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
]

export default farms
